<template>
  <div class="mentors-list px-1 w-100">
    <b-row class="mb-3 px-3">
      <b-col
        v-for="mentor in locMentors.slice(0, count)"
        :key="mentor.id"
        cols="12"
        :md="layout === 'vertical' ? 12 : 4"
        class="p-2"
      >
        <mentor-item
          :company="company"
          :mentor="mentor"
          :user="user"
          :layout="layout"
          :job="job"
          @submitContactMentorRequest="($event) => $emit('submitContactMentorRequest', { mentor, form: $event })"
        />
      </b-col>
      <b-col v-if="layout !== 'vertical' && count === 3 && locMentors.length < 3" class="p-2" cols="12" :md="layout === 'vertical' ? 12 : (12 - 4 * locMentors.length)">
        <b-card
          class="h-100 p-5 text-center d-flex flex-column justify-content-center align-items-center"
          style="min-height: 260px"
          no-body
        >
          <div>
            <div v-if="!locMentors.length">It looks like we don't have any mentors that fit your profile right now.</div>
            <div v-else>It looks like we have {{ locMentors.length }} {{ locMentors.length === 1 ? 'mentor' : 'mentors' }} that {{ locMentors.length === 1 ? 'fits' : 'fit' }} your profile right now.</div>
            <div>To see more we recommend you to <b-link :to="{ name: 'ProfileEdit' }">keep your profile updated</b-link>.</div>
            <div>or</div>
            <div>You can visit the <b-link :to="{ name: 'MentorsIndex' }">mentors page to checkout all the available mentors</b-link>.</div>
          </div>
        </b-card>
      </b-col>
      <b-col v-else-if="layout === 'vertical' && count === 3 && locMentors.length < 1" class="p-2" cols="12">
        <b-card
          class="h-100 p-5 text-center d-flex flex-column justify-content-center align-items-center"
          style="min-height: 260px"
          no-body
        >
          <div>
            <div class="mb-2">It looks like we don't have any mentors that could help you prepare for this job right now.</div>
            <div>You can visit the <b-link :to="{ name: 'MentorsIndex' }">mentors page to checkout all the available mentors</b-link>.</div>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" class="px-2">
        <b-button
          class="float-right mt-3 px-4"
          variant="outline-primary"
          :to="{ name: 'MentorsIndex' }"
        >View All</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import MentorItem from '@/components/mentors/MentorItem.vue';

export default {
  name: 'SuggestedMentors',
  components: { MentorItem },
  props: {
    mentors: {
      type: Array,
      default: () => [],
    },
    count: {
      type: Number,
      default: 4,
    },
    company: {
      type: Object,
      default: () => null,
    },
    layout: {
      type: String,
      default: 'default',
    },
    user: {
      type: Object,
      default: () => null,
    },
    job: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    locMentors() {
      const { mentors, count } = this;
      console.log({ mentors, count });
      return (Array.isArray(mentors) ? mentors : []).slice(0, count);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/dashboard/SuggestedMentors.vue